/* tslint:disable */
/* eslint-disable */

import { ReaderFragment } from "relay-runtime";
import { FragmentRefs } from "relay-runtime";
export type ItemTagTooltip_tag = {
    readonly name: string | null;
    readonly similarItems: {
        readonly creator: {
            readonly name: string | null;
        } | null;
        readonly category: {
            readonly name: string | null;
        } | null;
        readonly searchUrl: string | null;
    } | null;
    readonly " $refType": "ItemTagTooltip_tag";
};
export type ItemTagTooltip_tag$data = ItemTagTooltip_tag;
export type ItemTagTooltip_tag$key = {
    readonly " $data"?: ItemTagTooltip_tag$data;
    readonly " $fragmentRefs": FragmentRefs<"ItemTagTooltip_tag">;
};



const node: ReaderFragment = (function(){
var v0 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "name",
  "args": null,
  "storageKey": null
},
v1 = [
  (v0/*: any*/)
];
return {
  "kind": "Fragment",
  "name": "ItemTagTooltip_tag",
  "type": "TradePhotoTag",
  "metadata": null,
  "argumentDefinitions": [],
  "selections": [
    (v0/*: any*/),
    {
      "kind": "LinkedField",
      "alias": null,
      "name": "similarItems",
      "storageKey": null,
      "args": null,
      "concreteType": "SimilarItemsResults",
      "plural": false,
      "selections": [
        {
          "kind": "LinkedField",
          "alias": null,
          "name": "creator",
          "storageKey": null,
          "args": null,
          "concreteType": "Creator",
          "plural": false,
          "selections": (v1/*: any*/)
        },
        {
          "kind": "LinkedField",
          "alias": null,
          "name": "category",
          "storageKey": null,
          "args": null,
          "concreteType": "Category",
          "plural": false,
          "selections": (v1/*: any*/)
        },
        {
          "kind": "ScalarField",
          "alias": null,
          "name": "searchUrl",
          "args": null,
          "storageKey": null
        }
      ]
    }
  ]
};
})();
(node as any).hash = 'bae964febbb63108f720bf4b27a9044b';
export default node;
